import { FactoryInstance } from '../../../factory';
import { Line } from './Line';
export * from './Line';
FactoryInstance.registerComponent(Line, 'Line');
